export default function logoutUser(history) {
    localStorage.removeItem('jwt_token');
    history.push('/');
}